<div class="users-management" [class.users-management--nested-drawer-open]="hasNestedManagementDrawerOpen()">
  <div class="detail-toast" *ngIf="toastVisible" [ngClass]="'toast--' + toastType">
    <div class="toast__icon">
      <i
        [class]="
          toastType === 'success' ? 'pi pi-check' : toastType === 'error' ? 'pi pi-trash' : 'pi pi-exclamation-triangle'
        "
      >
      </i>
    </div>
    <div class="toast__message">
      <ng-container *ngIf="toastMessage === 'delete-success'; else plainToast">
        {{ 'usersManagement.user' | translate }} <span class="toast__username">"{{ toastUserName }}"</span>
        {{ 'usersManagement.movedTo' | translate }}
        <strong class="toast__highlight">{{ 'usersManagement.deletedItems' | translate }}</strong>
      </ng-container>
      <ng-template #plainToast>
        <ng-container *ngIf="toastUserName; else plainMsg">
          {{ 'usersManagement.user' | translate }} <span class="toast__username">"{{ toastUserName }}"</span>
          {{ toastMessage }}
        </ng-container>
        <ng-template #plainMsg>{{ toastMessage }}</ng-template>
      </ng-template>
    </div>
    <button class="toast__close" (click)="toastVisible = false"><i class="pi pi-times"></i></button>
  </div>
  <div class="page-header">
    <h1>{{ 'usersManagement.title' | translate }}</h1>
  </div>
  <div class="stats-grid">
    <div class="stat-card">
      <div class="stat-card__label">{{ 'usersManagement.totalUsers' | translate }}</div>
      <div class="stat-card__icon stat-card__icon--orange">
        <img src="assets/layout/images/logo-bg-white.svg" alt="logo" width="24" height="24" />
      </div>
      <div class="stat-card__value">{{ totalUsers }}</div>
      <div class="stat-card__sub">{{ 'usersManagement.allAccounts' | translate }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">{{ 'usersManagement.proUsers' | translate }}</div>
      <div class="stat-card__icon stat-card__icon--orange">
        <i class="pi pi-star-fill"></i>
      </div>
      <div class="stat-card__value">
        {{ activeUsers }}
      </div>
      <div class="stat-card__sub">{{ activePercent }}% {{ 'usersManagement.ofTotal' | translate }}</div>
    </div>
  </div>

  <div class="table-card-wrapper">
    <div class="table-card">
      <div class="filters-bar">
        <button class="btn-filter" (click)="toggleFilters()">
          <i class="pi pi-filter"></i>{{ 'usersManagement.filters' | translate
          }}<i class="pi" [ngClass]="showFilters ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </button>
        <span class="search-wrapper">
          <i class="pi pi-search"></i>
          <input
            type="text"
            [placeholder]="'usersManagement.searchUser' | translate"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChanged()"
          />
        </span>
      </div>

      <ng-container *ngIf="showFilters">
        <div class="filter-options">
          <div class="filter-group filter-group--date">
            <label>{{ 'usersManagement.createdAt' | translate }}</label>
            <div class="date-range-wrapper">
              <p-calendar
                [(ngModel)]="startDate"
                [placeholder]="'usersManagement.startDate' | translate"
                dateFormat="dd/mm/yy"
                appendTo="body"
                styleClass="date-input"
              />
              <span class="date-separator">→</span>
              <p-calendar
                [(ngModel)]="endDate"
                [placeholder]="'usersManagement.endDate' | translate"
                dateFormat="dd/mm/yy"
                [showIcon]="true"
                [minDate]="startDate"
                appendTo="body"
                styleClass="date-input"
              />
            </div>
          </div>
          <div class="filter-group filter-group--date">
            <label>{{ 'usersManagement.lastLogin' | translate }}</label>
            <div class="date-range-wrapper">
              <p-calendar
                [(ngModel)]="startLoginDate"
                [placeholder]="'usersManagement.startDate' | translate"
                dateFormat="dd/mm/yy"
                appendTo="body"
                styleClass="date-input"
              />
              <span class="date-separator">→</span>
              <p-calendar
                [(ngModel)]="endLoginDate"
                [placeholder]="'usersManagement.endDate' | translate"
                dateFormat="dd/mm/yy"
                [showIcon]="true"
                [minDate]="startLoginDate"
                appendTo="body"
                styleClass="date-input"
              />
            </div>
          </div>
          <div class="filter-group">
            <label>{{ 'usersManagement.userType' | translate }}</label>
            <p-dropdown
              [options]="userTypeOptions"
              [(ngModel)]="selectedUserType"
              optionLabel="label"
              optionValue="value"
              styleClass="filter-dropdown"
              panelStyleClass="filter-dropdown-panel"
            />
          </div>
          <div class="filter-group">
            <label>{{ 'usersManagement.userStatus' | translate }}</label>
            <p-dropdown
              [options]="statusOptions"
              [(ngModel)]="selectedStatus"
              optionLabel="label"
              optionValue="value"
              styleClass="filter-dropdown"
              panelStyleClass="filter-dropdown-panel"
            />
          </div>
          <div class="filter-group">
            <label>{{ 'usersManagement.cityLabel' | translate }}</label>
            <input
              type="text"
              class="filter-text-input"
              [placeholder]="'usersManagement.exactCity' | translate"
              [(ngModel)]="cityFilter"
              (keyup.enter)="applyFilters()"
            />
          </div>
          <div class="filter-group">
            <label>{{ 'usersManagement.completionRange' | translate }}</label>
            <div class="completion-range-wrapper">
              <input
                type="number"
                class="filter-text-input filter-text-input--narrow"
                min="0"
                max="100"
                [placeholder]="'usersManagement.min' | translate"
                [(ngModel)]="completionMin"
                (keyup.enter)="applyFilters()"
              />
              <span class="completion-range-separator">-</span>
              <input
                type="number"
                class="filter-text-input filter-text-input--narrow"
                min="0"
                max="100"
                [placeholder]="'usersManagement.max' | translate"
                [(ngModel)]="completionMax"
                (keyup.enter)="applyFilters()"
              />
            </div>
          </div>
          <div class="filter-actions">
            <button type="button" class="filter-apply-btn" (click)="applyFilters()">
              <i class="pi pi-check"></i>
              {{ 'usersManagement.apply' | translate }}
            </button>
            <button type="button" class="filter-apply-btn" [disabled]="exportingCsv" (click)="exportCsv()">
              <i class="pi" [ngClass]="exportingCsv ? 'pi-spin pi-spinner' : 'pi-download'"></i>
              {{ exportingCsv ? 'Exporting' : 'Export CSV' }}
            </button>
            <button type="button" class="filter-reset-btn" (click)="resetFilters()">
              <i class="pi pi-refresh"></i>
              {{ 'usersManagement.resetAll' | translate }}
            </button>
          </div>
        </div>
      </ng-container>

      <p-table
        [value]="users"
        [loading]="loading()"
        [lazy]="true"
        [customSort]="true"
        (onLazyLoad)="onLazyLoad($event)"
        [sortField]="sortField"
        [sortOrder]="sortOrder"
        [totalRecords]="totalUsers"
        [first]="first"
        [paginator]="true"
        [rows]="pageSize"
        [rowsPerPageOptions]="[10, 25, 50]"
        paginatorDropdownAppendTo="body"
        styleClass="users-table"
        [tableStyle]="{ 'table-layout': 'fixed', width: '100%' }"
        [showCurrentPageReport]="false"
      >
        <ng-template pTemplate="paginatorleft">
          <span class="users-pagination-report">{{ paginationReportText }}</span>
        </ng-template>
        <ng-template pTemplate="colgroup">
          <colgroup>
            <col class="col-name" />
            <col class="col-temperature" />
            <col class="col-created" />
            <col class="col-user-type" />
            <col class="col-status" />
            <col class="col-last-login" />
            <col class="col-completion" />
            <col class="col-notification" />
            <col class="col-activities" />
            <col class="col-sports" />
            <col class="col-action" />
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name" class="col-name">
              {{ 'usersManagement.user' | translate }} <p-sortIcon field="name" />
            </th>
            <th class="col-temperature col--center">{{ 'usersManagement.engagement' | translate }}</th>
            <th pSortableColumn="createdAt" class="col-created col--center">
              {{ 'usersManagement.createdOn' | translate }}
              <span class="col-sort-icon"><p-sortIcon field="createdAt" /></span>
            </th>
            <th pSortableColumn="userType.label" class="col-user-type col--center">
              {{ 'usersManagement.proColumn' | translate }}
              <span class="col-sort-icon"><p-sortIcon field="userType.label" /></span>
            </th>
            <th pSortableColumn="status" class="col-status col--center">
              {{ 'usersManagement.status' | translate }}
              <span class="col-sort-icon"><p-sortIcon field="status" /></span>
            </th>
            <th pSortableColumn="lastLoginDate" class="col-last-login col--center">
              {{ 'usersManagement.lastLoginHeader' | translate }}
              <span class="col-sort-icon"><p-sortIcon field="lastLoginDate" /></span>
            </th>
            <th pSortableColumn="profileCompletion" class="col-completion col--center">
              {{ 'usersManagement.profileCompletion' | translate }}
              <span class="col-sort-icon"><p-sortIcon field="profileCompletion" /></span>
            </th>
            <th class="col-notification col--center col-notification-header">
              <span class="col-notification-header__text">{{ 'usersManagement.pushNotification' | translate }}</span>
            </th>
            <th class="col-activities col--center">{{ 'usersManagement.activities' | translate }}</th>
            <th class="col-sports col--center">{{ 'usersManagement.sports' | translate }}</th>
            <th class="col-action col--center">{{ 'usersManagement.actions' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-user>
          <tr class="clickable-row" (click)="openSheet(user)">
            <!-- One stacked cell instead of three columns: the table breathes
                 and long values truncate instead of colliding. -->
            <td class="col-name">
              <div class="user-cell">
                <bo-users-management-user-avatar
                  [avatar]="user.avatar"
                  [firstName]="user.firstName ?? ''"
                  [lastName]="user.lastName ?? ''"
                  size="normal"
                />
                <span class="user-cell-stack" [pTooltip]="user.email" tooltipPosition="top">
                  <b class="user-name-cell">
                    <ng-container *ngIf="user.hasProfile !== false; else emailOnlyName">
                      {{ user.firstName }} {{ user.lastName }}
                    </ng-container>
                    <ng-template #emailOnlyName>{{ user.email }}</ng-template>
                  </b>
                  <small class="email-cell">{{ user.email }}</small>
                  <small class="city-cell" *ngIf="user.city">{{ user.city }}</small>
                </span>
              </div>
            </td>
            <td class="col-temperature col--center">
              <!-- The label carries the meaning; the colour only reinforces it,
                   so nothing is lost in print or to a colourblind reader. -->
              <span
                *ngIf="user.temperature; else temperatureUnknown"
                class="temperature-badge"
                [attr.data-temperature]="user.temperature"
                [pTooltip]="temperatureTooltip(user.temperature)"
                tooltipPosition="top"
                >{{ temperatureLabel(user.temperature) }}</span
              >
              <ng-template #temperatureUnknown><span class="temperature-unknown">-</span></ng-template>
            </td>
            <td class="col-created col--center">{{ user.createdAt | date : 'dd/MM/yyyy' }}</td>
            <!-- Pro or not is the useful signal; the exact role rides the
                 tooltip instead of taking a column's width. -->
            <td class="col-user-type col--center">
              <span
                *ngIf="user.userType && user.userType.key !== 'USER'; else standardAccount"
                class="pro-chip"
                [pTooltip]="'usersManagement.types.' + user.userType.key | translate"
                tooltipPosition="top"
                >PRO</span
              >
              <ng-template #standardAccount><span class="user-type-empty">—</span></ng-template>
            </td>
            <td class="col-status col--center">
              <span class="badge" [ngClass]="getStatusBadgeClass(user.status)">{{
                (user.status === 'Active' ? 'usersManagement.active' : 'usersManagement.inactive') | translate
              }}</span>
            </td>
            <td class="col-last-login col--center">
              {{ user.lastLoginDate ? user.lastLoginDate.split(' ')[0] : '' }}
            </td>
            <td class="col-completion col--center">
              <div
                class="completion-cell"
                [pTooltip]="(user.profileCompletion ?? 0) + '% complete'"
                tooltipPosition="top"
              >
                <span class="completion-cell__bar">
                  <span
                    class="completion-cell__fill"
                    [ngClass]="completionClass(user.profileCompletion)"
                    [style.width.%]="user.profileCompletion ?? 0"
                  ></span>
                </span>
                <span class="completion-cell__value">{{ user.profileCompletion ?? 0 }}%</span>
              </div>
            </td>
            <td class="col-notification col--center">
              <i
                class="pi notification-icon"
                [ngClass]="
                  user.notification ? 'pi-check-circle notification-icon--on' : 'pi-times-circle notification-icon--off'
                "
              ></i>
            </td>
            <td class="col-activities col--center">{{ user.activities ?? 0 }}</td>
            <td class="col-sports col--center">{{ user.sportsCount ?? 0 }}</td>
            <td class="col-action">
              <div class="action-btns" (click)="$event.stopPropagation()">
                <button
                  class="action-btn action-btn--edit"
                  (click)="openDrawerInEditMode(user)"
                  [pTooltip]="'usersManagement.editUser' | translate"
                  tooltipPosition="left"
                  appendTo="body"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                  </svg>
                </button>
                <button
                  class="action-btn action-btn--delete"
                  (click)="openDeleteConfirm(user)"
                  [pTooltip]="'usersManagement.deleteUser' | translate"
                  tooltipPosition="left"
                  appendTo="body"
                >
                  <i class="pi pi-trash" style="font-size: 18px"></i>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" class="empty-msg">{{ 'usersManagement.noUsers' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<bo-delete-user-confirm-dialog
  [visible]="showDeleteDialog"
  [userName]="selectedUser?.name ?? ''"
  [confirmed]="deleteConfirmed"
  [deleting]="deletingUser"
  [credit]="creditOnDeletion"
  (visibleChange)="showDeleteDialog = $event"
  (confirmedChange)="deleteConfirmed = $event"
  (cancelled)="onDeleteDialogCancelled()"
  (deleteConfirmed)="confirmDelete()"
/>

<bo-delete-user-blocked-dialog
  [visible]="showDeleteBlockedDialog"
  [content]="deleteBlockedContent"
  [canSuspend]="true"
  [alreadySuspended]="!!selectedUser?.suspension"
  [suspending]="suspendingUser"
  (visibleChange)="showDeleteBlockedDialog = $event"
  (closed)="onDeleteBlockedDialogClosed()"
  (suspendRequested)="suspendSelectedUser($event)"
/>

<bo-user-detail
  [(visible)]="drawerVisible"
  [user]="selectedUser"
  [initialMode]="drawerInitialMode"
  [nestedManagementDrawerOpen]="hasNestedManagementDrawerOpen()"
  (visibleChange)="onDrawerVisibleChange($event)"
  (editUser)="editUser($event)"
  (deleteUserRequested)="openDeleteConfirm($event)"
  (liftSuspensionRequested)="liftSuspension($event)"
  (activityOpen)="onUserActivityOpen($event)"
  (groupOpen)="onUserGroupOpen($event)"
/>

<bo-activity-drawer-host
  #userActivityDrawer
  [embeddedInUserDetail]="true"
  [dismissibleOnMaskClick]="true"
  [sportTypeConfigs]="sportTypeConfigs"
  [sportOptions]="sportOptions"
  [defaultCoverPhotoUrl]="defaultCoverPhotoUrl"
  (visibilityChange)="onUserActivityVisibilityChange($event)"
  (sessionChange)="onUserActivitySessionChange()"
/>

<bo-groups-management
  #userGroupDrawers
  [drawerOnly]="true"
  [embeddedInUserDetail]="true"
  [drawerBaseZIndex]="1100"
  (nestedDrawerVisibilityChange)="onNestedGroupDrawerVisibilityChange()"
/>

<p-sidebar
  [visible]="sheetUserId !== null"
  (visibleChange)="!$event && closeSheet()"
  position="right"
  styleClass="user-sheet-sidebar"
  [modal]="true"
  [dismissible]="true"
  [showCloseIcon]="true"
>
  <bo-user-profile *ngIf="sheetUserId" [userId]="sheetUserId" />
</p-sidebar>
